var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconConcierge = function SvgIconConcierge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19511_79802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3713 2.7824L9.62174 0.032L7.93214 1.7216L6.21054 0L3.46094 2.7496L5.18254 4.4712L5.18174 4.472L7.93214 7.2216L10.6825 4.472L10.6817 4.4712L12.3713 2.7824Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46094 13.2175L6.21054 15.9679L7.90014 14.2783L9.62174 15.9999L12.3713 13.2503L10.6497 11.5287L10.6505 11.5279L7.90014 8.77832L5.14974 11.5279V11.5287L3.46094 13.2175Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2185 12.4092L15.9689 9.65965L14.2793 7.97005L16.0009 6.24845L13.2513 3.49805L11.5297 5.21965H11.5289L8.7793 7.97005L11.5289 10.7204L11.5297 10.7196L13.2185 12.4092Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7824 3.49805L0.032 6.24845L1.7216 7.93805L0 9.65965L2.7496 12.4092L4.4712 10.6876H4.472L7.2216 7.93805V7.93725L4.472 5.18765H4.4712L2.7824 3.49805Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19511_79802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
};
export default SvgIconConcierge;